<template>
  <div class="main-body pb-10">
    <div class="bg-white shadow-xl w-full rounded-xl p-6">
      <div class="flex justify-between">
        <div class="flex items-center">
          <div>
            <el-image class="w-32 shadow-xl rounded-xl" :src="detail.thumb">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="pl-4">
            <p>{{ detail.name }}</p>
            <div class="mt-4">
              <el-tag>标签一</el-tag>
            </div>
          </div>
        </div>
        <div>
          <el-progress type="circle" :width="90" :percentage="25"></el-progress>
        </div>
      </div>
      <div class="pt-6">
        <p>
          {{ detail.desc }}
          本课程通过实战开发，从基础原理逐步深入讲解React中的主流技术以及实战中的应用。课程讲解全部使用React18最新语法，让同学们全方位理解应用React构建项目，直接上手中级以上难度React项目开发。
        </p>
      </div>
    </div>

    <el-tabs class="course mt-8 home-tabs" value="first">
      <el-tab-pane label="课程目录" name="first">
        <div class="bg-white shadow-xl w-full rounded-xl p-6 mt-6">
          <div class="cursor-pointer" @click="handlePlay(item,index)"  v-for="(item,index) in detail.hours" :key="item.id">
            <div
                class="transition flex items-center justify-between duration-500 hover:bg-red-100 rounded-xl hover:shadow mt-1 transform hover:-translate-y-1 p-4">
              <div class="">
                <i class="el-icon-video-play"></i>
                {{ item.alias }}
              </div>
              <div v-if="item.play">
                <div v-if="item.learningPercent !== 0 && item.learningPercent < 100">
                  <el-button type="text" class="text-gray-300	">上次学习到：{{videoTime(item.learningTime)}}</el-button>
                  <el-button type="text">继续学习</el-button>
                </div>
                <div v-else-if="item.learningPercent === 100">
                  <el-button type="text" class="text-green-400">学习完成</el-button>
                </div>
                <div v-else>
                  <el-button type="text">开始学习</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="课程附件" name="second">
        <div class="bg-white shadow-xl w-full rounded-xl p-6 mt-6">
          展示内容2
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {videoTime} from "@/utils/function";

export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {},
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      detail: {}
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {
    if (this.$route.query.id) {
      this.handleLoadData()
    }
  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    handleLoadData() {
      $cloud.get("/course/detail", {id: this.$route.query.id}).then(data => {
        this.detail = data
      })
    },
    videoTime(second){
      return videoTime(second)
    },
    handlePlay(item,index){
      console.log("去播放",item,index)
      if(item.play){
        this.$router.push({path:'/pages/web/play',query:{id:item.id,cid:this.detail.id,index:index}})
      }

    }
  }
};
</script>
<style>
.course.el-tabs .el-tabs__content {
  overflow: visible
}
</style>
